/*
 * Import common js to use common function in this javascript file
 */
import { deleteConfirmationAlert, commonClockTimepicker, commonDatepicker, reservationDatepicker, select2Dropdown } from "./common";
import { searchByTableColumns } from "./common";
import Glide from '@glidejs/glide';
import swal from 'sweetalert2';
window.Swal = swal;

window.Glide = Glide;


var startTime = '';
var endTime = '';
var tableId = '';
let resExpOpenTime = '';
let resOpenTime    = '';
let resExpCloseTime = '';
let resCloseTime = '';
let askedConfirmation = false;
let checkCover = false;

/**
 * Disable mousewheel
 */
window.$("#reservation_date").bind("mousewheel", function () {
    if ($.browser.webkit === true) {
        return false;
    }
});

/**
 * Reservation store
 */
window.$(document).on('click', ".saveReservations", function (e) {
    e.preventDefault();
    window.$(".error").html('');
    window.toastr.remove();
    window.$('.saveReservations').attr('disabled', 'disabled');
    window.axios({
        method: "post",
        url: window.$(".reservationsForm").attr('action'),
        data: window.$(".reservationsForm").serialize(),
    })
        .then(function (response) {
            window.toastr.success(response.data.message, response.statusText);
            if (window.$(".timeMatrixCalender").length !== 1) {
                setTimeout(function () {
                    window.location = response.data.redirectTo;
                }, 1000);
            } else {
                window.$('.closebtn').trigger('click');
                renderCalendar($("#lastRenderURL").val() + '?index=true&date=' + $("#visible_start").val() + '&area_id=' + window.$('#area').val());
            }

        })
        .catch(function (error) {
            window.$('.saveReservations').removeAttr('disabled');
            if (error.response.status == 400) {
                window.$.each(error.response.data, function (key, value) {
                    window.$('#' + key + '-error').text(value[0]);
                });
            } else if (error.response.status == 500) {
                window.toastr.error(error.response.data.message, error.response.statusText);
            }
        });
    return false;
});

/**
 * Reservation update
 */
window.$(document).on('click', '.updateReservations', function (e) {
    e.preventDefault();
    window.$(".error").html('');
    window.toastr.remove();
    window.$('.updateReservations').attr('disabled', 'disabled');
    window.axios({
        method: "PUT",
        url: window.$(".updateReservationsForm").attr('action'),
        data: window.$(".updateReservationsForm").serialize(),
    })
        .then(function (response) {
            window.toastr.success(response.data.message, response.statusText);
            if (window.$(".timeMatrixCalender").length !== 1) {
                // setTimeout(function () {
                //     window.location = response.data.redirectTo;
                // }, 1000);
                window.$('.closebtn').trigger('click');
                $('.reservationsTable').DataTable().ajax.reload(null, false);
            } else {
                window.$('.closebtn').trigger('click');
                renderCalendar($("#lastRenderURL").val() + '?index=true&date=' + $("#visible_start").val() + '&area_id=' + window.$('#area').val());
            }
        })
        .catch(function (error) {
            window.$('.updateReservations').removeAttr('disabled');
            if (error.response.status == 400) {
                window.$.each(error.response.data, function (key, value) {
                    window.$('#' + key + '-error').text(value[0]);
                });
            } else if (error.response.status == 500) {
                window.toastr.error(error.response.data.message, error.response.statusText);
            }
        });
    return false;
});
window.$(document).on('click', '.guest .close', function (e) {
    window.$('#add_new_guest').modal('toggle');
});
window.$(document).on('hidden.bs.modal', '#add_new_guest', function () {
    document.getElementsByTagName("body")[0].style.removeProperty('transform');
});
window.$(document).on('keypress', '#guest_search', function (event) {
    if (event.keyCode == 13) {
        event.preventDefault();
    }
})
//Open modal and intialize select2
window.$(document).on('click', '#add_new_guest_bt', function (e) {
    e.preventDefault();
    // var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    // if (isSafari) {
    //     document.getElementsByTagName("body")[0].style.transform = "translate3d(0,0,0)";
    // }
    window.$('#add_new_guest').modal('toggle');
    //document.getElementsByTagName("body")[0].style.transform = "translate3d(0,0,0)";
    window.axios({
        method: "post",
        url: window.$(this).attr('data-url'),
        data: {}
    })
        .then(function (response) {
            window.$('#modal_content').html(response.data);
            // window.$('#guestFormContent').html(response.data);
            // var modal = document.getElementById("create-guest-modal");
            // modal.style.display = "block";
            setTimeout(() => {
                $('html, body').animate({
                    'scrollTop': $("#add_new_guest").position().top
                });
            }, 250);
            setTimeout(function () {
                // let spanClose = modal.querySelector('.close');
                // spanClose.onclick = function() {
                //     modal.style.display = "none";
                //     document.getElementsByTagName("body")[0].style.removeProperty('transform');
                // }
                commonDatepicker();
                select2Dropdown();
                var input = document.querySelector("#phone_code");
                var phone_code = window.intlTelInput(input, {
                    separateDialCode: true,
                    preferredCountries: ["fi", "se"],
                });
            }, 1000);

            window.$('.guest-heading').css({ 'margin': 0, 'margin-top': '10px' });
            window.$('.guest-heading .close').attr('hidden', false);
            window.$('.back-button-div').attr('hidden', true);
            window.$('.saveGuest').parent('div').addClass('col-md-12');
            window.$('.modal-backdrop').css({ 'z-index': 0 });
        });
})

window.$(document).on("click", ".guestEditIcon", function () {
    window.$('#add_new_guest').modal('toggle');
    window.axios({
        method: "post",
        url: window.$(this).attr('data-url'),
        data: {
            'id': window.$("#guest_id").val()
        }
    })
        .then(function (response) {
            window.$('#modal_content').html(response.data);
            //window.$('#guestFormContent').html(response.data);
            var modal = document.getElementById("add_new_guest");
            // modal.style.display = "block";
            setTimeout(() => {
                modal.querySelector("#guestReservation").remove();
                $('html, body').animate({
                    'scrollTop': $("#add_new_guest").position().top
                });
            }, 250)
            setTimeout(function () {
                // let spanClose = modal.querySelector('.close');
                // spanClose.onclick = function() {
                //     modal.style.display = "none";
                //     document.getElementsByTagName("body")[0].style.removeProperty('transform');
                // }
                commonDatepicker();
                select2Dropdown();
                var input = document.querySelector("#phone_code");
                var phone_code = window.intlTelInput(input, {
                    separateDialCode: true,
                    preferredCountries: ["fi", "se"],
                });
            }, 1000);
            window.$('.guest-heading').css({ 'margin': 0, 'margin-top': '10px' });
            window.$('.guest-heading .close').attr('hidden', false);
            window.$('.back-button-div').attr('hidden', true);
            window.$('.updateGuest').parent('div').addClass('col-md-12');
            window.$('.modal-backdrop').css({ 'z-index': 0 });
        })
});
window.$(document).on("click", ".guestDeleteIcon", function () {
    window.$('#guest_id').val('');
    window.$('#guest_name').text();
    window.$('#guest_email').text();
    window.$('#guest_phone_number').text();
    window.$('.guest_information').attr('hidden');
    window.$('.guest_information').addClass('d-none');

});
// Show reservation in sidebar modal
window.$(document).on("click", ".viewReservation", function () {
    window.$("#sidebarNavRight").css('width', '500px');

    window.axios({
        method: "get",
        url: window.$(this).attr('data-url'),
        // responseType: 'blob', // important
    })
        .then(function (response) {
            // const url = window.URL.createObjectURL(new Blob([response.data]));
            // const link = document.createElement('a');
            // link.href = url;
            // link.setAttribute('download', 'file.pdf'); //or any other extension
            // document.body.appendChild(link);
            // link.click();
            window.$('#sidebar-modal-content').html(response.data);
        })
});
// Show reservation in sidebar modal
window.$(document).on("click", ".viewReservationInTimeMatrix", function (async) {
    const date = $(this).attr('date'),
        area_id = $(this).attr('area_id'),
        restaurant_id = $(this).attr('restaurant_id'),
        reservation_id = $(this).attr('reservation_id');
    ;
    // var eventURL = "/core/timematrix/create?index=true&date=" + date + "&area_id=" + area_id + "&restaurant_id=" + restaurant_id + "";
    window.location.href = "/core/"+restaurant_id+"/timematrix/create?date=" + date + "&area_id=" + area_id + "&restaurant_id=" + restaurant_id + "&reservation_id=" + reservation_id + "&src=guest_history";
});

//PDF DOWNLOAD
window.$(document).on("click", ".downloadReservationPdf", function () {
    let name = $(this).attr('downloadname');
    window.axios({
        method: "get",
        url: window.$(this).attr('data-url'),
        responseType: 'blob', // important
    })
        .then(function (response) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', name); //or any other extension
            document.body.appendChild(link);
            link.click();
        })
});

// Edit reservation in sidebar modal
window.$(document).on("click", ".editReservation", function () {
    window.$("#sidebarNavRight").css('width', '500px');
    
    window.axios({
        method: "post",
        url: window.$(this).attr('data-url'),
        data: {
            'id': window.$(this).attr('data-id')
        }
    })
        .then(function (response) {
            window.$('#sidebar-modal-content').html(response.data);
            setTimeout(function () {
                commonDatepicker();
                select2Dropdown();
                reservationDatepicker();
                $('.editor').richText();
            }, 1000);

        })
});

window.$(document).on('click', '#reservation_date', function () {
    window.$('.closebtn').trigger('click');
});
window.$(document).on('click', ".area-field > span:eq(0)", function () {
    window.$('.closebtn').trigger('click');
});
// Add reservation in sidebar modal
window.$(document).on("click", ".closebtn", function () {
    window.$("#sidebarNavRight").css('width', '0');
    $('.fc-timeline-lane').css('background-color','');
});
// Add reservation in sidebar modal
window.$(document).on("click", ".reservationBackButton", function () {
    window.$("#sidebarNavRight").css('width', '0');
});
window.$(document).on("click", ".createReservation", function (event, triggerFrom) {
    if (triggerFrom === 'dateClick')
        checkCover = true;
    else
        checkCover = false;

    window.$("#sidebarNavRight").css('width', '500px');
    if (triggerFrom === undefined) {
        startTime = '';
        endTime = '';
    }
    setTimeout(function () {
        $('.editor').richText();
        window.$(".reservation-datepicker").val(window.$('#reservation_date').val());
        $("#area_id").select2().val(window.$("#area").val()).trigger("change");
    }, 1000);
    window.axios({
        method: "post",
        url: window.$(this).attr('data-url'),
        data: {
            'guestId': $(this).attr('data-guestId'),
            'src': $(this).attr('data-src'),
            'restaurantId': window.$('#restaurants').val(),
            'areaId': window.$('#area_filter').val(),
            'tabelId': tableId,
            'date': window.$('#reservation_date').val(),
            'startTime': startTime,
            'endTime': endTime,
        }
        // data: {'guestId':$(this).attr('data-guestId'),'src':$(this).attr('data-src')}
    })
        .then(function (response) {
            window.$('#sidebar-modal-content').html(response.data);
            setTimeout(function () {
                commonDatepicker();
                if(startTime==''){
                    select2Dropdown('currentTime');
                }else{
                    select2Dropdown();
                }
                reservationDatepicker();
                renderTimeList();
            }, 1000);
        })
});

// Walk in reservation
window.$(document).on("click", ".walkin", function (event, triggerFrom) {
    window.$("#sidebarNavRight").css('width', '500px');
    if (triggerFrom === undefined) {
        startTime = '';
        endTime = '';
    }
    setTimeout(function () {
        window.$("#label-reservation_date").val(window.$('#reservation_date').val());
        $("#area_id").select2().val(window.$("#area").val()).trigger("change");
    }, 1000);
    window.axios({
        method: "post",
        url: window.$(this).attr('data-url'),
        data: {
            'guestId': $(this).attr('data-guestId'),
            'src': $(this).attr('data-src'),
            'restaurantId': window.$('#restaurants').val(),
            'areaId': window.$('#area_filter').val(),
            'tabelId': tableId,
            'date': window.$('#reservation_date').val(),
            'startTime': startTime,
            'endTime': endTime,
        }
    })
        .then(function (response) {
            window.$('#sidebar-modal-content').html(response.data);
            setTimeout(function () {
                commonDatepicker();
                if(startTime == ''){
                    select2Dropdown('currentTime');
                }else{
                    select2Dropdown();
                }
                reservationDatepicker();
                renderTimeList();
            }, 1000);
        })
});


window.$(document).on('change', '#label-reservation_date', function (e) {
    getAvailableTable();
    calculateRetentionHour();
    showReservationStatus();

    //     // get available slots
    //     window.axios({
    //         method: "post",
    //         url: window.$(".reservationsForm #slotTime").data('url'),
    //         data: window.$(".reservationsForm").serialize(),
    //     })
    //     .then(function(response) {
    //         let optionDom = '';
    //         if(response.data.availableSlots.length > 0){
    //             let slots = response.data['availableSlots'];
    //             for(let prop in slots){
    //                 optionDom += '<option data-tokens="'+slots[prop]+'" value="'+slots[prop]+'">'+slots[prop]+'</option>';
    //             }
    //             $("#start_time").html(optionDom);
    //             $("#end_time").html(optionDom);
    //         }else{
    //             $("#start_time").html(optionDom);
    //             $("#end_time").html(optionDom);
    //         }
    //     })
    //     .catch(function(error) {
    //         if (error.response !== 'undefined' && error.response.status == 400) {

    //         }
    //     });
})
// Populate combination tables dropdown for selected area
window.$(document).on('change', '.reservationsForm .get_available_tables', function (e) {
    // get available table
    getAvailableTable();
});
function getAvailableTable() { 
   // window.$('#tables_id').empty();
    window.axios({
        method: "post",
        url: window.$(".reservationsForm #area_id").data('url'),
        data: window.$(".reservationsForm").serialize(),
    })
        .then(function (response) {
    
            window.$('#tablesSelectInput').html(response.data);
            window.$('.reservationsForm .multi-selection').select2({
                placeholder: DROPDOWN_MULTI_SELECT_PLACEHOLDER,
                templateResult: formatOption
            });
        })
        .catch(function (error) {
            if (error.response !== 'undefined' && error.response.status == 400) {
                window.$.each(error.response.data, function (key, value) {
                    window.$('#' + key + '-error').text(value[0]);
                });
            }
        });
}
function showReservationStatus() {
    window.axios({
        method: "post",
        url: window.$(".updateReservationsForm #reservationStatus").data('url'),
        data: window.$(".updateReservationsForm").serialize(),
    })
        .then(function (response) {
            window.$('#reservationStatus').html(response.data);
            window.$('.reservationsForm .single-selection').select2({
                placeholder: DROPDOWN_SINGLE_SELECT_PLACEHOLDER,
                templateResult: formatOption
            });
        })
        .catch(function (error) {
            console.log(error);
            // if (error.response !== 'undefined' && error.response.status == 400) {
            //     window.$.each(error.response.data, function (key, value) {
            //         window.$('#' + key + '-error').text(value[0]);
            //     });
            // }
        });
}

function formatOption(option) {
    var $option = $(
        '<div class="table-heading">' + option.text + '</div><small class="text-secondary ">' + option.title + '</small>'
    );
    return $option;
};
// Autocomplete guest search
$(document).on("focus", "#guest_search", function (e) {
    if (!$(this).data("autocomplete")) { // If the autocomplete wasn't called yet:
        $(this).autocomplete({ //   call it
            appendTo:'#autocomplete-cont',
            source: function (request, response) {
                // Fetch data
                $.ajax({
                    url: window.$('#guest_search').data('url'),
                    type: 'post',
                    dataType: "json",
                    data: {
                        _token: window.$('meta[name="csrf-token"]').attr('content'),
                        search: request.term,
                        restaurant_id: window.$('#restaurants').val()
                    },
                    success: function (data) {
                        response(data);
                    }
                });
            },
            minLength:3,
            select: function (event, ui) {
                window.$('#guest_search').val('');
                window.$('#guest_id').val(ui.item.guest_id);
                window.$('#guest_name').text(ui.item.first_name + ' ' + ui.item.last_name);
                window.$('#guest_email').text(ui.item.email);
                window.$('#guest_phone_number').text(ui.item.phone_number);
                window.$('.guest_information').removeAttr('hidden');
                window.$('.guest_information').removeClass('d-none');
                return false;
            }
        });
    }
});

/**
 * Guest table listing
 */
let reservationDisplayRecords;
let reservationTotalRecords;
var table = window.$('.reservationsTable').DataTable({
    // scrollY: 400,
    // scrollX: true,
    // scroller: true,
    "oLanguage": DATATABLE_LANGUAGE_OPTIONS,
    "aLengthMenu": DATATABLE_MENU_LENGTH_OPTIONS,
    processing: true,
    serverSide: true,
    "bAutoWidth": true,
    fixedHeader: {
        header: true,
        headerOffset: 205,
        },
    order: [

    ],
    "ajax": {
        "url": window.$(".reservationsTable").attr('link') + '?date=' + window.$("#datatable_search_date").val() + '&status=' + window.$('#reservation_status_filter').val() + '&areas_id=' + window.$('#area_filter').val() + '&reservation_phases_id=' + window.$('#reservation_phase_filter').val(),
        data: function (d) {
                d.status = window.$('#reservation_status_filter').val(),
                d.areas_id = window.$('#area_filter').val(),
                d.reservation_phases_id = window.$('#reservation_phase_filter').val(),
                d.reservation_date = window.$('#datatable_search_date').val(),
                d.iTotalDisplayRecords = reservationDisplayRecords;
                d.iTotalRecords = reservationTotalRecords;
                setTimeout(() => {
                    window.$('.reservation_phase_lists').select2({
                        placeholder: DROPDOWN_SINGLE_SELECT_PLACEHOLDER,
                    });
                    let dropdown = $('.reservation_phase_lists');
                    for (let index = 0; index < dropdown.length; index++) {
                        const element = $('.reservation_phase_lists:eq(' + index + ')').val()
                        if (element == "") {
                            $('.reservation_phase_lists:eq(' + index + ')').next('span').addClass('d-none');
                        }
                    }
                    $(".reservation_phase_lists").nextAll('span').addClass('d-none')

                    // $("[phase_dropdown=" + id + "]").select2('close')
                    window.$(".phaseIconInList").show();
                    window.$(".phasediv").show();

                }, 1000);
        }
    },
    "initComplete": function (settings, res) {
        reservationDisplayRecords = res.iTotalDisplayRecords;
        reservationTotalRecords = res.iTotalRecords;


    },
    columns: [
        { data: 'action', name: 'action', orderable: false, searchable: false,width: '4%' },
        { data: 'id', name: 'id', "visible": false },
        { data: 'status', name: 'status'  },
        { data: 'date', name: 'date'  },
        { data: 'slot', name: 'slot'  },
        { data: 'guest_details', name: 'guest_details', className:'guest_detail'  },
        { data: 'no_of_guests', name: 'no_of_guests'  },
        { data: 'area', name: 'area' },
        { data: 'phase', name: 'phase'  },
        { data: 'reservation_code', name: 'reservation_code' },
    ],
});

window.$(document).on('change', '#reservation_status_filter ', function (e) {
    table.draw();
});

window.$(document).on('change', '#area_filter ', function (e) {
    table.draw();
});

window.$(document).on('change', '#reservation_phase_filter ', function (e) {
    table.draw();
});
window.$(document).on('change', '#datatable_search_date ', function (e) {
    table.draw();
});

window.$(document).ready(function () {
    // Setup - add a text input to each footer cell
    var excluded_columns = [1];
    searchByTableColumns(table, '.reservationsTable', excluded_columns);

});

// Cancel reservation
window.$(document).on('click', '.reservationWrapper .cancelReservation', function (e) {

    window.$(".error").html('');
    window.toastr.remove();
    // Call method for delete confirmation
    let reservationCancelMsg = 'Are you sure you want to cancel the reservation?'
    var promise = deleteConfirmationAlert(reservationCancelMsg);
    promise.then(function (result) {
        var myTable = $(".reservationsTable").DataTable({
            bRetrieve: true,
            ajax: window.$(".reservationsTable").attr('link'),
            initComplete: function () { }
        });
        window.axios({
            method: "put",
            url: window.$(".updateReservationsForm").attr('action'),
            data: {
                'cancel_reservation': true
            }
        })
            .then(function (response) {
                window.toastr.success(response.data.message, response.statusText);
                if (window.$(".timeMatrixCalender").length !== 1) {
                    myTable.ajax.reload();
                    window.$('.closebtn').trigger('click');
                } else {
                    setTimeout(function () {
                        window.$('.closebtn').trigger('click');
                        window.$("#dailyModal").css("display", "none");
                        renderCalendar($("#lastRenderURL").val() + '?index=true&date=' + $("#visible_start").val() + '&area_id=' + window.$('#area').val());
                    }, 1000)


                    //renderCalendar($("#lastRenderURL").val() + '?index=true&date=' + $("#visible_start").val() + '&area_id=' + window.$('#area').val());
                }
            })
    }).catch(function (err) {
        // console.log(err);
        return false;
    });
});
// Cancel reservation
window.$(document).on('click', '.reservationWrapper .cancelReservationList', function (e) {
    let url = window.$(this).attr('link')
    window.$(".error").html('');
    window.toastr.remove();
    // Call method for delete confirmation
    let reservationCancelMsg = 'Are you sure you want to cancel the reservation?'
    var promise = deleteConfirmationAlert(reservationCancelMsg);
    promise.then(function (result) {
        var myTable = $(".reservationsTable").DataTable({
            bRetrieve: true,
            ajax: window.$(".reservationsTable").attr('link'),
            initComplete: function () { }
        });
        window.axios({
            method: "put",
            url: url,
            data: {
                'cancel_reservation': true
            }
        })
            .then(function (response) {
                // console.log("hi")
                window.toastr.success(response.data.message, response.statusText);
                if (window.$(".timeMatrixCalender").length !== 1) {
                    // console.log("yes")
                    myTable.ajax.reload();
                    // window.$('.closebtn').trigger('click');
                } else {
                    setTimeout(function () {
                        window.$('.closebtn').trigger('click');
                        window.$("#dailyModal").css("display", "none");
                        renderCalendar($("#lastRenderURL").val() + '?index=true&date=' + $("#visible_start").val() + '&area_id=' + window.$('#area').val());
                    }, 1000)


                    //renderCalendar($("#lastRenderURL").val() + '?index=true&date=' + $("#visible_start").val() + '&area_id=' + window.$('#area').val());
                }
            })
    }).catch(function (err) {
        // console.log(err);
        return false;
    });
});
// Time Matrix
// Calander plugins
var calendar = '';
import { Calendar, diffDates, elementClosest } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import momentPlugin from '@fullcalendar/moment'
import interactionPlugin, { Draggable } from '@fullcalendar/interaction';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import Swal from "sweetalert2";
import { difference } from "lodash";
import e from "jquery-datetimepicker";
import { nodeName } from "jquery";



let interval_slotDuration = '';
let interval_slotLabelInterval = '';

let pad = (num) => {
    num = num.toString();
    num = "0" + num;
    return num;
};
if (window.$(".container-fluid").hasClass('timeMatrixCalender')) {
    document.addEventListener('DOMContentLoaded', function () {
        var qs = (function (a) {
            if (a == "") return {};
            var b = {};
            for (var i = 0; i < a.length; ++i) {
                var p = a[i].split('=', 2);
                if (p.length == 1)
                    b[p[0]] = "";
                else
                    b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
            }
            return b;
        })(window.location.search.substr(1).split('&'));

        var start_date = getDateFormat();
        $("#visible_start").val(start_date);
        var intervalLink = $("#timematrixCalendar").attr('intervalLink');
        var eventURL = window.$("#timematrixCalendar").attr('link') + '?index=true&date=' + start_date + '&area_id=' + window.$('#area').val();
        if (qs['reservation_id'] != '' && qs['src'] !== 'guest_history') {
            window.axios({
                method: "get",
                url: intervalLink,
                data: {}
            })
                .then(function (response) {
                    let intervalTime = response.data.data;
                    if (intervalTime == '+2 hours') {
                        interval_slotDuration = '02:00:00';
                        interval_slotLabelInterval = { hour: 2, minutes: pad(0) };
                    } else if (intervalTime == '+15 minutes') {
                        interval_slotDuration = '00:15:00';
                        interval_slotLabelInterval = { minutes: 15 };
                    } else if (intervalTime == '+30 minutes') {
                        interval_slotDuration = '00:30:00';
                        interval_slotLabelInterval = { minutes: 30 };
                    } else if (intervalTime == '+1 hour') {
                        interval_slotDuration = '01:00:00';
                        interval_slotLabelInterval = { hour: 1, minutes: pad(0) };
                    } else if (intervalTime == '1 hour 30_minutes') {
                        interval_slotDuration = '01:30:00';
                        interval_slotLabelInterval = { hour: 1, minutes: 30 };
                    }
                    renderCalendar(eventURL);
                });
        }
        var start_date_split = start_date.split("-")
        var formated_start_date = start_date_split[2] + '.' + start_date_split[1] + '.' + start_date_split[0];
        $('#reservation_date').val(formated_start_date);
        getDailsNotes(start_date);
        if (qs['reservation_id'] != '' && qs['src'] == 'guest_history') {
            $("#visible_start").val(qs['date']);
            $("#area").select2().val(qs['area_id']).trigger("change");
            getDailsNotes(qs['date']);
            var start_date_split = qs['date'].split("-")
            var formated_start_date = start_date_split[2] + '.' + start_date_split[1] + '.' + start_date_split[0];

            $('#reservation_date').val(formated_start_date);
            // setTimeout(() => {
            window.$("#sidebarNavRight").css('width', '500px');

            let url = "/core/"+qs['restaurant_id']+"/reservation/" + qs['reservation_id']
            window.axios({
                method: "get",
                url: url
            })
                .then(function (response) {
                    window.$('#sidebar-modal-content').html(response.data);
                    window.history.pushState({}, document.title, "/" + "core/"+qs['restaurant_id']+"/timematrix/create");
                })
            // }, 2000);

        }



        if (qs['guestId'] != '' && qs['src'] == 'guest') {
            $(".createReservation").trigger('click');
        }
        window.$(document).on('change', "#area_id", function (e) {
            let selectedArea = $(this).val();
            $("#area").select2().val(selectedArea).trigger("change");
        });
        if (qs['reservation_id'] != '' && qs['src'] == 'redirect') {
            $("#visible_start").val(qs['date']);
            $("#area").select2().val($("#area").val()).trigger("change");
            getDailsNotes($("#visible_start").val());
            var start_date_split = qs['date'].split("-")
            var formated_start_date = start_date_split[2] + '.' + start_date_split[1] + '.' + start_date_split[0];
            // console.log(formated_start_date)
            $('#reservation_date').val(formated_start_date);
            window.history.pushState({}, document.title, "/" + "core/"+qs['restaurant_id']+"/timematrix/create");
        }


    });
}

function renderCalendar(eventURL) {
    var calendarEl = document.getElementById('timematrixCalendar');
    $("#lastRenderURL").val(window.$("#timematrixCalendar").attr('link'));
    var resourcesObject = '';
    var eventsObject = '';
    var scrollTime = moment().format("HH:mm");

    var indicatorColorSet = [];
    var indicatorColors = 
    ['#1a0571',
    '#719365',
    '#70ec3a',
    '#ea2275',
    '#0b09d6',
    '#631581',
    '#89d5b6',
    '#01280e',
    '#001c32',
    '#e996d2',
    '#a61254',
    '#fe56c5',
    '#21be2e',
    '#c14b33',
    '#9fbe7f',
    '#6fddcb',
    '#c46bc4',
    '#cf3218',
    '#9250bf',
    '#0c59fd',
    '#44e3d9',
    '#dbb87b',
    '#7cb0db',
    '#3d59f8',
    '#e2c5e3',
    '#b9e638',
    '#69ab15',
    '#aada72',
    '#0ba1f8',
    '#03a9d4',
    '#b5ecb9',
    '#f57ea4',
    '#9c6347'];

    Promise.resolve(1).then(function resolve() {
        window.axios({
            method: "get",
            url: eventURL + '&restaurant_id=' + $('#restaurants').val(),
            data: {
                'date':window.$("#reservation_date").val(),
                'area_id':window.$("#area").val()
            }
        })
            .then(function (response) {
                resourcesObject = response.data.resources;
                let matrixInfo  = response.data.matrixInfo;
                let coverHeading  = response.data.coverData;
                // RESERVATION TIME
                 if(matrixInfo.reservationTime.length == 0){
                     window.$("[for='matrixinforeservationtime']").hide();
                     window.$("#matrixinforeservationtime").hide();
                 }else{
                    window.$("#matrixinforeservationtime").html('');
                    let t = '';
                    
                    for (const [key, value] of Object.entries(matrixInfo.reservationTime)) {
                        let meal = key.charAt(0).toUpperCase() + key.slice(1);
                        t += `<span style="padding-right:7px;">${meal}: ${value}</span>`;
                    }
                    window.$("#matrixinforeservationtime").html(t);
                    window.$("[for='matrixinforeservationtime']").show();
                    window.$("#matrixinforeservationtime").show();
                 }
                 // RESERVATION CLOSE TIME
                if(matrixInfo.reservationCloseTime.length == 0){
                    window.$("[for='matrixinforeservationclosetime']").hide();
                    window.$("#matrixinforeservationclosetime").hide();
                }else{
                    window.$("#matrixinforeservationclosetime").html('');
                    let c = '';
                    

                    for (const [key, value] of Object.entries(matrixInfo.reservationCloseTime)) {
                        let meal = key.charAt(0).toUpperCase() + key.slice(1);
                        
                        if(value.length == 1){
                            c += ` <span style="">${meal}</span>: ${value[0]}`;
                        }else if(value.length > 1){
                            c += ` <span style="">${meal}</span>: `;
                        let cp = '';
                        let ic = 1;
                        for (let i = 0; i < value.length; i++) {
                            cp += `&nbsp; <span>Slot-${ic}: ${value[i]}</span>,`;
                            ic++;
                        }

                        c += cp;
                    }
                       
                    }
                    window.$("#matrixinforeservationclosetime").html(c);
                    window.$("[for='matrixinforeservationclosetime']").show();
                    window.$("#matrixinforeservationclosetime").show();
                }
                 // EXCEPTION OPEN TIME
                 if(matrixInfo.exceptionOpen.length > 0){
                    window.$("#matrixinfoexceptiontime").html('');
                    let r = '';
                    let inc = 1;
                    for(let k of matrixInfo.exceptionOpen){
                       r += `<span style="padding-right:7px;">Slot-${inc}: ${k}</span>`;
                       inc++;
                    }

                    window.$("#matrixinfoexceptiontime").html(r);
                    window.$("[for='matrixinfoexceptiontime']").show();
                    window.$("#matrixinfoexceptiontime").show();
                 }else{
                    window.$("[for='matrixinfoexceptiontime']").hide();
                    window.$("#matrixinfoexceptiontime").hide();
                 }
                 // EXCEPTION CLOSE TIME
                 if(matrixInfo.exceptionClose.length > 0){
                    window.$("#matrixinfoexceptionclosetime").html('');
                    let r = '';
                    let inc = 1;
                    for(let k of matrixInfo.exceptionClose){
                       r += `<span style="padding-right:7px;">Slot-${inc}: ${k}</span>`;
                       inc++;
                    }

                    window.$("#matrixinfoexceptionclosetime").html(r);
                    window.$("[for='matrixinfoexceptionclosetime']").show();
                    window.$("#matrixinfoexceptionclosetime").show();
                 }else{
                    window.$("[for='matrixinfoexceptionclosetime']").hide();
                    window.$("#matrixinfoexceptionclosetime").hide();
                 }
                 resExpOpenTime = JSON.parse(JSON.parse(JSON.stringify(response.data.timing.resExpOpenTime)));
                 resOpenTime    = JSON.parse(JSON.parse(JSON.stringify(response.data.timing.resOpenTime)));
                 resExpCloseTime = JSON.parse(JSON.parse(JSON.stringify(response.data.timing.resExpCloseTime)));
                 resCloseTime = JSON.parse(JSON.parse(JSON.stringify(response.data.timing.resCloseTime)));
                 let timematrixTableHideFlag = false;
                 let resURL     = window.$('.timeMatrixCalender').attr('resTimeUrl');
                 let staticTemp = `<div class="card text-center timematrixHideDivCard" id="timematrixHideDiv" style="cursor:default;">
                 <div class="card-body">
                     Restaurant is closed today.</br>
                     You can edit your opening times <a href="${resURL}" style="color:blue !important;">here.</a>
                 </div>
                 </div>`;
                 if(resOpenTime.length == 0 && resExpOpenTime.length == 0){
                    window.$(".timeMatrixCalender .add_new_btn").css("pointer-events:none");
                    window.$(".timeMatrixCalender .add_new_btn").attr('disabled',true);
                    window.$(".timeMatrixCalender .createDailyNotes").attr('disabled',false);
                    window.$("#matrixinfodom").hide();
                    window.$("#timematrixCalendar").hide();
                    setTimeout(function(){

                    
                    window.$("#timematrixCalendar").children(".fc-view-harness").hide();
                    window.$(".timematrixHideDivCard").remove();
                    //if(window.$(".timematrixHideDivCard").length == 0){
                       window.$(staticTemp).insertAfter('.fc-header-toolbar');
                       window.$("#timematrixCalendar").show();
                    //}
                   // window.$("#timematrixHideDiv").show();
                    },750);
                    timematrixTableHideFlag = true;
                    //return false;
                }else{
                    window.$("#matrixinfodom").show();
                    window.$("#timematrixHideDiv").hide();
                    window.$(".timeMatrixCalender .add_new_btn").css("pointer-events:''");
                    window.$(".timeMatrixCalender .add_new_btn").attr('disabled',false);
                    //window.$("#timematrixCalendar").show();
                    window.$("#timematrixCalendar").children(".fc-view-harness").show();
                }
                 window.$("#reservationOpenTime").val(resOpenTime);
                 window.$("#reservationExceptionOpenTime").val(resExpOpenTime);
                 window.$("#reservationExceptionCloseTime").val(resExpCloseTime);
                 window.$("#reservationCloseTime").val(resCloseTime);
                var strTime = '00:00';
                if(resOpenTime[0] && resExpOpenTime[0]){
                    var strTime = resExpOpenTime[0] < resOpenTime[0]?resExpOpenTime[0]:resOpenTime[0];
                }else if(resOpenTime[0] && !resExpOpenTime[0]){
                    var strTime =   resOpenTime[0];
                }else if(! resOpenTime[0] && resExpOpenTime[0]){
                    var strTime =   resExpOpenTime[0];
                }
                
                eventsObject = response.data.events;
                
                var keyCount = 0;
                $.each(eventsObject, function(key, event) {
                    var objKey = event.id
                    if(!(objKey in indicatorColorSet)){
                        indicatorColorSet[objKey] = keyCount;
                        keyCount++;
                    }
                    if(keyCount > 34){
                        keyCount = 0;
                    }
                });

                calendar = new Calendar(calendarEl, {
                    headerToolbar: {
                        left: ''
                    },
                    plugins: [momentPlugin, resourceTimelinePlugin, interactionPlugin, dayGridPlugin, timeGridPlugin, listPlugin],
                    events: eventsObject,
                    initialView: 'resourceTimeline',
                    schedulerLicenseKey: 'GPL-My-Project-Is-Open-Source',
                    height: 'auto',
                    nowIndicator: 'true',
                    now: ($("#visible_start").val()) ? $("#visible_start").val() : getDate(),
                    scrollTime: scrollTime,
                    slotDuration: interval_slotDuration,
                    slotLabelInterval: interval_slotLabelInterval,
                    slotMinTime:strTime,
                    //slotMaxTime: endTime,
                    slotLabelFormat: {
                        hour: 'numeric',
                        minute: '2-digit',
                        omitZeroMinute: false,
                        hour12: false,
                    },
                    slotLabelContent:function(date){
                        let slotTime = date.text;
                        let hasKey = slotTime in coverHeading;
                        let formatTxt;
                        let totalCover, bookedCover;
                        totalCover = 0,bookedCover = 0;
                        if(hasKey){
                            let coverDetails = coverHeading[slotTime];
                            totalCover = coverDetails.totalCover;
                            bookedCover = coverDetails.bookedCover;
                        }
                        if(totalCover === 0){
                            formatTxt = bookedCover;
                        }else{
                            formatTxt = bookedCover+'/'+totalCover;
                        }
                        return date.text={html:slotTime+'</br>'+'<span class="time_cover">'+formatTxt+'</span>'};
                    },
                    locale: 'en-GB',
                    eventTimeFormat: {
                        hour: '2-digit', //2-digit, numeric
                        minute: '2-digit', //2-digit, numeric
                        second: '2-digit', //2-digit, numeric
                        meridiem: false, //lowercase, short, narrow, false (display of AM/PM)
                        hour12: false //true, false
                    },
                    editable: true, // enable draggable events
                    aspectRatio: 1.8,
                    slotEventOverlap: false,
                    //scrollTime: '00:00', // undo default 6am scrollTime
                    // visibleRange: {
                    //     start: ($("#visible_start").val()),
                    //     end: ($("#visible_end").val())
                    // },
                    resourceAreaHeaderContent: 'Table / Max',
                    resources: resourcesObject,
                    resourceOrder: 'sortOrder',
                    selectable: true,
                    selectHelper: true,
                    expandThrough: false,
                    resourceAreaWidth: '10%',
                    multiple_selection: true,
                    eventDidMount: function(info) {
                        $(info.el).tooltip({
                            html:true,
                            title: (info.event._def.extendedProps.title_tooltip),
                            placement: 'bottom',
                            trigger: 'hover',
                            container: 'body',
                            delay: { "show": 50, "hide": 50 }
                        });
                        difference = Math.abs(info.event.end - info.event.start) / 1000;
                        let hours = Math.floor(difference / 3600) % 24;
                        let minutes = Math.floor(difference / 60) % 60;
                        let positionElement = info.el.parentElement.parentElement;
                        let cellHeightElement = info.el.parentElement.parentElement.parentElement;
                        let rightElement = info.el.parentElement;
                          if(hours < 4 && [15,30,45,0].includes(minutes)){
                            var rect = rightElement.getBoundingClientRect();
                            //  cellHeightElement.style.height='39px';
                            // positionElement.style.removeProperty('position');
                            rightElement.style.whiteSpace='nowrap';
                            if(interval_slotDuration == '00:15:00'){
                                if(hours == 0){
                                    info.el.classList.add('showToolTip');
                                    if(minutes == 15){
                                        //info.el.style.width='50px';
                                    }else if(minutes == 30){
                                        //info.el.style.width='100px';
                                    }else if(minutes == 45){
                                        //info.el.style.width='150px';
                                    }
                                }else if(hours == 1){
                                    info.el.classList.add('showToolTip');
                                    if(minutes == 0){
                                        //info.el.style.width = '200px';
                                    }else if(minutes == 15){
                                        //info.el.style.width='250px';
                                    }else if(minutes == 30){
                                        //info.el.style.width='300px';
                                    }else if(minutes == 45){
                                        //info.el.style.width='350px';
                                    }
                                }
                            }else if(interval_slotDuration == '00:30:00'){
                                if(hours == 0){
                                    if(minutes == 30){
                                        //info.el.style.width='50px';
                                    }else if(minutes == 45){
                                        //info.el.style.width='100px';
                                    }
                                }else if(hours == 1){
                                    if(minutes == 0){
                                        //info.el.style.width = '100px';
                                    }else if(minutes == 30){
                                        //info.el.style.width='150px';
                                    }else if(minutes == 45){
                                        //info.el.style.width='200px';
                                    }
                                }

                            }else if(interval_slotDuration == '01:00:00'){
                                if(hours == 0){
                                    if(minutes == 0){
                                        //info.el.style.width='50px';
                                    }
                                }else if(hours == 1){
                                    if(minutes == 0){
                                        //info.el.style.width = '100px';
                                    }else if(minutes == 30){
                                        //info.el.style.width = '150px';
                                    }
                                }

                            }else if(interval_slotDuration == '01:30:00'){

                            }
                            
                            
                        }else{
                            positionElement.style.setProperty('position','relative');
                        }
                    },
                    eventContent: function (arg) {
                        if (arg.event._def.extendedProps.reservation_status == 'Seated') {
                            arg.backgroundColor = '#6998C6';
                            arg.borderColor = '#6998C6'
                        } else if (arg.event._def.extendedProps.reservation_status == 'Delay') {
                            arg.backgroundColor = '#F2DA7F';
                            arg.borderColor = '#F2DA7F';
                            arg.textColor = 'black';
                        } else if (arg.event._def.extendedProps.reservation_status == 'Overtime') {
                            arg.backgroundColor = '#F2827F';
                            arg.borderColor = '#F2827F';
                            arg.textColor = 'black';
                        } else if (arg.event._def.extendedProps.reservation_status == 'Not Confirmed') {
                            arg.backgroundColor = '#EAAF3E';
                            arg.borderColor = '#EAAF3E';
                            arg.textColor = 'black';
                        } else if (arg.event._def.extendedProps.reservation_status == 'Checked out') {
                            arg.backgroundColor = '#8B8E78';
                            arg.borderColor = '#8B8E78';
                            arg.textColor = 'white';
                        } else if (arg.event._def.extendedProps.reservation_status == 'Partly seated') {
                            arg.backgroundColor = '#5BA6F1';
                            arg.borderColor = '#5BA6F1';
                            arg.textColor = 'black';
                        } else if (arg.event._def.extendedProps.reservation_status == 'No show') {
                            arg.backgroundColor = 'red';
                            arg.borderColor = 'red';
                            arg.textColor = 'black';
                        } else {
                            //arg.backgroundColor = 'linear-gradient(111deg, rgba(41,0,62,1) 95%, rgba(255,175,0,1) 95%)';
                            //arg.borderColor = 'green';
                            //arg.textColor = 'white';
                        }
                        if (arg.event._def.extendedProps.status == 'open') {
                            let italicEl = document.createElement('i');
                            var guestNumberShape = document.createElement('span');
                            var phaseIcon = document.createElement('img');
                            phaseIcon.className = 'phaseIcon phaseIconColor ml-2';
                            guestNumberShape.className = 'guestNumberShape';
                            guestNumberShape.innerHTML = arg.event._def.extendedProps.no_of_guests;
                            phaseIcon.src = arg.event._def.extendedProps.reservation_icon !== "" ? arg.event._def.extendedProps.reservation_icon : "";
                            italicEl.innerHTML = arg.event._def.title;
                            
                            let colorIndicator = document.createElement('span');
                            colorIndicator.className = 'colorIndicator';
                            colorIndicator.style = "background-color: " + indicatorColors[indicatorColorSet[arg.event._def.publicId]];

                            
                            arg.event._def.extendedProps.reservation_icon !== "" ? italicEl.append(phaseIcon) : null;
                            italicEl.prepend(guestNumberShape);
                            
                            //console.log(arg.event)

                            let arrayOfDomNodes = [italicEl, colorIndicator];
                            return { domNodes: arrayOfDomNodes }



                        } else if (arg.event._def.extendedProps.status == 'block') {
                            arg.backgroundColor = 'rgb(96 71 131)';
                            arg.borderColor = 'rgb(96 71 131)'
                        }
                    },
                    resourceLabelDidMount: function (info) {
                        var closeMark = document.createElement('strong');
                        closeMark.innerText = ' X ';
                        var status = info.resource._resource.extendedProps.status;
                        if (status == 'inactive') {
                            info.el.style.backgroundColor = 'black';
                            info.el.querySelector('.fc-datagrid-cell-main')
                                .classList.add('resource_bg');
                            info.el.querySelector('.fc-datagrid-cell-main')
                                .appendChild(closeMark);
                        }
                        info.el.querySelector('.fc-datagrid-cell-cushion')
                            .classList.add('centerAlign');
                        info.el.querySelector('.fc-datagrid-cell-frame')
                            .setAttribute('id', info.resource._resource.extendedProps.table_id);

                    },
                    eventResize: function (info) {
                        var infoData = info.event._def.extendedProps.data;
                        let status = info.event._def.extendedProps.status;
                        if (status == 'open') {
                            if (infoData.action == "show") {
                                alert('You can not dragged previous regervations');
                                info.revert();
                            } else {
                                if (!confirm("You are changing the reservation time! Are you sure about this change?")) {
                                    info.revert();
                                } else {
                                    var startStr = info.event.startStr;
                                    var startDate = new Date(startStr);
                                    var startHours = startDate.getHours();
                                    var startMinutes = startDate.getMinutes();
                                    var startTime = startHours + ':' + startMinutes;

                                    var endStr = info.event.endStr;
                                    var endDate = new Date(endStr);
                                    var endHours = endDate.getHours();
                                    var endMinutes = endDate.getMinutes();
                                    var endTime = endHours + ':' + endMinutes;

                                    Promise.resolve(1).then(function resolve() {
                                        window.axios({
                                            method: "post",
                                            url: infoData.url,
                                            data: {
                                                'id': infoData.reservation_id,
                                                'start_time': startTime,
                                                'end_time': endTime,
                                                'reservationDragged': true,
                                            }
                                        })
                                            .then(function (response) {
                                                renderCalendar($("#lastRenderURL").val() + '?index=true&date=' + $("#visible_start").val() + '&area_id=' + window.$('#area').val());
                                            });
                                    });
                                }
                            }
                        } else if (status == 'block') {
                            if (!confirm("Are you sure about this change?")) {
                                info.revert();
                            } else {
                                blockTable(info, true);
                            }
                        }
                    },
                    eventDrop: function (info) {
                        $(info.el).tooltip("hide");
                        $('[data-toggle="tooltip"], .tooltip').tooltip("hide");
                        var infoData = info.event._def.extendedProps.data;
                        let status = info.event._def.extendedProps.status;
                        /*
                          oldreservationData
                          info.oldEvent._def.extendedProps.data.reservation_id;
                          info.oldEvent._def.extendedProps.data.table_id;
                          info.oldEvent.startStr;
                          info.oldEvent.endStr;
                        */
                        /*
                         let newStartTime = info.event.start;
                          let newEndTime = info.event.end;
                          newRservationTable
                          info.newResource._resource.extendedProps.table_id;
                        */
                       if (status == 'open') {
                            if (infoData.action != "show") {
                                alert('You can not dragged previous regervations');
                                info.revert();
                            } else {
                                if((typeof info.newResource !== 'undefined' && typeof info.oldResource !== 'undefined' && 
                                    info.newResource !== null && info.oldResource !== null && info.event.startStr != info.oldEvent.startStr) || (info.newResource === null && info.oldResource === null)){
                                    if (!confirm("You are changing the reservation time! Are you sure about this change?")) {
                                        info.revert();
                                    }
                                    else{
                                        dragAndDrop(info,infoData);
                                    }
                                 }
                                else{
                                    dragAndDrop(info,infoData); 
                                }
                            }
                        } else if (status == 'block') {
                            if (!confirm("Are you sure about this change?")) {
                                info.revert();
                            } else {
                                blockTable(info, true);
                            }
                        }
                    },
                    eventClick: function (info) {
                        //console.log('test');
                        var infoData = info.event._def.extendedProps.data;
                        var status = info.event._def.extendedProps.status;
                        if (status == 'open') {
                            window.$("#sidebarNavRight").css('width', '500px');
                            setTimeout(function () {
                                $('.editor').richText();
                            }, 1000);
                            Promise.resolve(1).then(function resolve() {
                                if (infoData.action == "show") {
                                    window.axios({
                                        method: "get",
                                        url: infoData.url
                                    })
                                        .then(function (response) {
                                            window.$('#sidebar-modal-content').html(response.data);
                                        })
                                } else {
                                    window.axios({
                                        method: "post",
                                        url: infoData.url,
                                        data: {
                                            'id': infoData.reservation_id
                                        }
                                    })
                                        .then(function (response) {
                                            window.$('#sidebar-modal-content').html(response.data);
                                            setTimeout(function () {
                                                commonDatepicker();
                                                select2Dropdown();
                                                reservationDatepicker();
                                            }, 1000);
                                        });
                                }
                            });
                        } else if (status == 'block') {
                            removeBlockTable(infoData);
                        }

                    },
                    dateClick: function (info) {
                        $(".fc-highlight").css("background", "#aaa");
                        // var startStr = info.dateStr;
                        // var startDate = new Date(startStr);
                        // var startHours = ('0' + startDate.getHours()).slice(-2);
                        // var startMinutes = ('0'+startDate.getMinutes()).slice(-2);
                        // startTime = startHours+':'+startMinutes;
                        // endTime = addTimes(startTime, RESERVATION_TIME_INVERVAL_HR);
                        // // var endMinutes = startMinutes.getMinutes() + 15;
                        // // endTime = startHours+':'+endMinutes;
                        // tableId = info.resource.extendedProps.table_id;
                        // setTimeout( function(){
                        //     window.$(".reservation-datepicker").val(window.$('#reservation_date').val());
                        //     $("#area_id").select2().val(window.$("#area").val()).trigger("change");
                        // },1000);
                        // setTimeout(function(){
                        //     $("#tables_id").select2().val(tableId).trigger("change");
                        // },2000)
                        // if(window.$("#sidebarNavRight").width() == '0'){
                        //     window.$(".createReservation").trigger('click',['dateClick']);
                        // }else if(window.$("#sidebarNavRight").width() >= '100'){
                        //     if($("form[class='reservationsForm'] > #reservation_type").val() == 'reservation'){
                        //         window.$(".createReservation").trigger('click',['dateClick']);
                        //     }else if($("form[class='reservationsForm'] > #reservation_type").val() == 'walkin'){
                        //         window.$(".walkin").trigger('click',['dateClick']);
                        //     }
                        // }
                    },
                    select: function (info) {
                        $(".fc-highlight").css("background", "#aaa");
                        confirmation(info);
                        askedConfirmation = true;
                        checkCover = true;
                        // var startStr = info.start;
                        // var startDate = new Date(startStr);
                        // var startHours = ('0'+startDate.getHours()).slice(-2);
                        // var startMinutes = ('0'+startDate.getMinutes()).slice(-2);
                        // startTime = startHours+':'+startMinutes;
                        // var endStr = info.end;
                        // var endDate = new Date(endStr);
                        // var endHours = ('0'+endDate.getHours()).slice(-2);
                        // var endMinutes = ('0'+endDate.getMinutes()).slice(-2);
                        // endTime = endHours+':'+endMinutes;
                        // tableId = info.resource.extendedProps.table_id;
                        // setTimeout( function(){
                        //     window.$(".reservation-datepicker").val(window.$('#reservation_date').val());
                        //     $("#area_id").select2().val(window.$("#area").val()).trigger("change");
                        // },1000);
                        // setTimeout(function(){
                        //     $("#tables_id").select2().val(tableId).trigger("change");
                        // },2000)
                        // if(window.$("#sidebarNavRight").width() == '0'){
                        //     window.$(".createReservation").trigger('click',['dateClick']);
                        // }else if(window.$("#sidebarNavRight").width() >= '100'){
                        //     if($("form[class='reservationsForm'] > #reservation_type").val() == 'reservation'){
                        //         window.$(".createReservation").trigger('click',['dateClick']);
                        //     }else if($("form[class='reservationsForm'] > #reservation_type").val() == 'walkin'){
                        //         window.$(".walkin").trigger('click',['dateClick']);
                        //     }
                        // }
                    },
                });
                calendar.render();
                let start = $("#visible_start").val();
                if (start !== "") {
                    var dateSelected = new Date(start);
                } else {
                    var dateSelected = new Date(getDate());
                }

                var weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                const monthNames = ["January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December"
                ];
                var p_day = weekday[dateSelected.getDay()];
                var p_date = ("0" + (dateSelected.getDate())).slice(-2);
                var p_month = monthNames[dateSelected.getMonth()];
                var p_year = dateSelected.getFullYear();
                dateSelected = p_day + ", " + p_date + " " + p_month + " " + p_year;
                let colorindicator = `&nbsp;&nbsp;&nbsp;
                    <div class="statusIndicator">
                        <div class='box res_confirmed'></div><span class='si dmsans'>Confirmed</span>
                    </div>
                    <div class="statusIndicator">
                        <div class='box res_seated'></div><span class='si dmsans'>Seated</span>
                    </div>
                    <div class="statusIndicator">
                        <div class='box res_partlyseated'></div><span class='si dmsans'>Partly seated</span>
                    </div>
                    <div class="statusIndicator">
                        <div class='box res_late'></div><span class='si dmsans'>Late</span>
                    </div>
                    <div class="statusIndicator">
                        <div class='box res_overtime'></div><span class='si dmsans'>OverTime</span>
                    </div>
                    <div class="statusIndicator">
                        <div class='box res_notconfirmed'></div><span class='si dmsans'>Not confirmed</span>
                    </div>
                    <div class="statusIndicator">
                        <div class='box res_checkedout'></div><span class='si dmsans'>Checked out</span>
                    </div>`;
                    let dateSelectedTxt = '';
                if(resOpenTime.length == 0 && resExpOpenTime.length == 0){
                    dateSelectedTxt = dateSelected;
                }else{
                    dateSelectedTxt = dateSelected + colorindicator;
                }
                
                $(".fc-toolbar-chunk").first().addClass("h2");
                $(".fc-toolbar-chunk").first().html(dateSelectedTxt);
                let pleaseWaitloader = "<div class='timeMatrixloader1'></div>&nbsp;&nbsp;<span class='matrixPleasewait' style='display:none; font-size: x-large;color: green !important;'>Please Wait...</span>";
                $(".fc-toolbar-chunk:eq(1)").html(pleaseWaitloader);
                $(".fc-today-button").removeAttr('disabled');

                //sked(response);
            });
    });

}

function openSideForm(info) {
    
    var startStr = info.start;
    var startDate = new Date(startStr);
    var startHours = ('0' + startDate.getHours()).slice(-2);
    var startMinutes = ('0' + startDate.getMinutes()).slice(-2);
    startTime = startHours + ':' + startMinutes;
    var endStr = info.end;
    var endDate = new Date(endStr);
    var endHours = ('0' + endDate.getHours()).slice(-2);
    var endMinutes = ('0' + endDate.getMinutes()).slice(-2);
    endTime = endHours + ':' + endMinutes;
    tableId = info.resource.extendedProps.table_id;
    
    setTimeout(function () {
        window.$(".reservation-datepicker").val(window.$('#reservation_date').val());
        $("#area_id").select2().val(window.$("#area").val()).trigger("change");
        if(!document.getElementById("selected_end_time") && document.getElementById("selected_end_time") != null && document.getElementById("selected_end_time").length == 0){
        var input = document.createElement("input");

        input.setAttribute("type", "hidden");
    
        input.setAttribute("id", "selected_end_time");
    
        input.setAttribute("value", endTime);
    
        //append to form element that you want .
        document.getElementById("sidebarNavRight").appendChild(input);
        }else{
            window.$("#selected_end_time").val(endTime);
        }
        window.$("#start_time").val(startTime).trigger("change");
    }, 1000);
    setTimeout(function () {
        $("#tables_id").select2().val(tableId).trigger("change");
        window.$('.reservationsForm .multi-selection').select2({
            placeholder: DROPDOWN_MULTI_SELECT_PLACEHOLDER,
            templateResult: formatOption
        });
    }, 2500)
    if (window.$("#sidebarNavRight").width() == '0') {
        window.$(".createReservation").trigger('click', ['dateClick']);
    } else if (window.$("#sidebarNavRight").width() >= '100') {
        if ($("form[class='reservationsForm'] > #reservation_type").val() == 'reservation') {
            window.$(".createReservation").trigger('click', ['dateClick']);
        } else if ($("form[class='reservationsForm'] > #reservation_type").val() == 'walkin') {
            window.$(".walkin").trigger('click', ['dateClick']);
        }
    }
    setTimeout(function(){
        window.$(".saveReservations").attr('disabled',false);
    },1000)
}

function removeBlockTable(infoData) {
    var promise = deleteConfirmationAlert('Are you sure you want to unblock the table?');
    promise.then(function (result) {
        // If confirmation true, do action for delete
        window.axios({
            method: 'DELETE',
            url: infoData.unblockTableUrl,
        }).then(function (response) {
            window.toastr.success(response.data.message, response.statusText);
            renderCalendar($("#lastRenderURL").val() + '?index=true&date=' + $("#visible_start").val() + '&area_id=' + window.$('#area').val());

        }).catch(function (error) {
            window.toastr.error(error.response.data.message, error.response.data.statusText);
        });
    }).catch(function (err) {
        // console.log(err);
        return false;
    });
}

function blockTable(info, editFlag = false) {
    let current_table_id = '';
    let new_table_id = '';
    let old_table_id = '';
    if(editFlag == true){
        current_table_id = info.event._def.extendedProps.data.table_id;
        new_table_id = (typeof info.newResource === 'undefined' || info.newResource === null) ? current_table_id: info.newResource._resource.extendedProps.table_id ;
        old_table_id = (typeof info.oldResource === 'undefined' || info.oldResource === null ) ? current_table_id : info.oldResource._resource.extendedProps.table_id;
    
    }
    if (editFlag == true) {
        var infoData = info.event._def.extendedProps.data;
        var startStr = info.event.startStr;
        var startDate = new Date(startStr);
        var startHours = startDate.getHours();
        var startMinutes = startDate.getMinutes();
        var startTime = startHours + ':' + startMinutes;

        var endStr = info.event.endStr;
        var endDate = new Date(endStr);
        var endHours = endDate.getHours();
        var endMinutes = endDate.getMinutes();
        var endTime = endHours + ':' + endMinutes;
    } else {
        var startStr = info.start;
        var startDate = new Date(startStr);
        var startHours = ('0' + startDate.getHours()).slice(-2);
        var startMinutes = ('0' + startDate.getMinutes()).slice(-2);
        startTime = startHours + ':' + startMinutes;
        var endStr = info.end;
        var endDate = new Date(endStr);
        var endHours = ('0' + endDate.getHours()).slice(-2);
        var endMinutes = ('0' + endDate.getMinutes()).slice(-2);
        endTime = endHours + ':' + endMinutes;
    }
    if (editFlag == true) {

        // tableId = info.newResource ? ._resource.extendedProps.table_id;
        if (info.newResource) {
            tableId = info.newResource._resource.extendedProps.tabe_id;
        }
        if (tableId == undefined) {
            tableId = info.event._def.extendedProps.data.table_id;
        }
        tableId = new_table_id;
    } else {
        tableId = info.resource.extendedProps.table_id;
    }
    let requestData = {
        _token: window.$('meta[name="csrf-token"]').attr('content'),
        date: $("#reservation_date").val(),
        area_id: $("#area").val(),
        table_id: tableId,
        startTime: startTime,
        endTime: endTime
    };
    let url = window.$('.timeMatrixCalender').attr('blockurl');
    let method = "post";
    if (editFlag == true) {
        url = infoData.extendedBlockTableUrl;
        method = "put";
    }
    window.axios({
        method: method,
        url: url,
        data: requestData,
    }).then(function (response) {
        window.toastr.success(response.data.message, response.statusText);
        renderCalendar($("#lastRenderURL").val() + '?index=true&date=' + $("#visible_start").val() + '&area_id=' + window.$('#area').val());
    }).catch(function (error) {
        if (error.response.status != 200) {
            window.toastr.error(error.response.data.message, error.response.statusText);
        }
    });
}

function confirmation(info) {
    Swal.fire({
        title: '<strong>Time Matrix</strong>',
        icon: 'info',
        allowOutsideClick: false,
        html: 'You can select <b>below action</b>',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'Save',
        focusConfirm: false,
        confirmButtonText: "<i class='fa fa-lock' aria-hidden='true'></i> Block Table",
        //confirmButtonAriaLabel: 'Thumbs up, great!',
        cancelButtonText: "<i class='fa fa-check' aria-hidden='true'></i> Make Reservation",
        // cancelButtonAriaLabel: 'Thumbs down',
        denyButtonText: "<i class='fa fa-times' aria-hidden='true'></i> Cancel",
    }).then((result) => {
        if (result['isConfirmed']) {
            blockTable(info);
        } else if (result['isDenied']) {

        } else if (result['isDismissed']) {
            sweetLoader();
            checkTimeIsAvailableWhileCalendar(info);
        }
    })
}
function checkTimeIsAvailableWhileCalendar(info)
{
  let startStr = info.start;
  let startDate = new Date(startStr);
  let startHours = ('0' + startDate.getHours()).slice(-2);
  let startMinutes = ('0' + startDate.getMinutes()).slice(-2);
  let startTime = startHours + ':' + startMinutes; 

  if(resOpenTime.length == 0 && resExpOpenTime.length == 0){
    Swal.fire({
        html: 'Restaurant not open in this time',
        title: '<strong>Time Matrix</strong>',
        icon: 'warning',
        allowOutsideClick: false,
    });
  }
    if(resOpenTime.includes(startTime) || resExpOpenTime.includes(startTime)){
        if(resCloseTime.length > 0 && resCloseTime.includes(startTime)){
            closeTimeConfirmation(info);
        }else if(resExpCloseTime.length > 0 && resExpCloseTime.includes(startTime)){
            closeTimeConfirmation(info);
        }else{
            openSideForm(info);
            Swal.close();
        }
    }else{
        Swal.fire({
            html: 'Restaurant not open in this time',
            title: '<strong>Time Matrix</strong>',
            icon: 'warning',
            allowOutsideClick: false,
        });
    }
}
function closeTimeConfirmation(info){
    Swal.fire({
        title: '<strong>Time Matrix</strong>',
        icon: 'info',
        allowOutsideClick: false,
        html: 'Please note, that your restaurant is closed for this time slot - are you sure you want to make a reservation?',
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: 'Yes',
        focusConfirm: false,
        cancelButtonText: "No",
    }).then((result) => {
        if (result['isConfirmed']) {
            openSideForm(info);
            
            Swal.close();
        } else if (result['isDenied']) {
            Swal.close();
        } else if (result['isDismissed']) {
            Swal.close();
        }
    })
}
function checkTimIsAvailableWhileTimeChange(startTime){
    window.$(".saveReservations").attr('disabled',true);
    if(resOpenTime.includes(startTime) || resExpOpenTime.includes(startTime)){
        if(resCloseTime.length > 0 && resCloseTime.includes(startTime)){
            Swal.fire({
                title: '<strong>Time Matrix</strong>',
                icon: 'info',
                allowOutsideClick: false,
                html: 'Please note, that your restaurant is closed for this time slot - are you sure you want to make a reservation?',
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                focusConfirm: false,
                cancelButtonText: "No",
            }).then((result) => {
                if (result['isConfirmed']) {
                    window.$(".saveReservations").attr('disabled',false);
                    Swal.close();
                    return true;
                } else if (result['isDenied']) {
                    Swal.close();
                    window.$(".saveReservations").attr('disabled',true);
                } else if (result['isDismissed']) {
                    Swal.close();
                    window.$(".saveReservations").attr('disabled',true);
                }
            })
        }else if(resExpCloseTime.length > 0 && resExpCloseTime.includes(startTime)){
            Swal.fire({
                title: '<strong>Time Matrix</strong>',
                icon: 'info',
                allowOutsideClick: false,
                html: 'Please note, that your restaurant is closed for this time slot - are you sure you want to make a reservation?',
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                focusConfirm: false,
                cancelButtonText: "No",
            }).then((result) => {
                if (result['isConfirmed']) {
                    window.$(".saveReservations").attr('disabled',false);
                    Swal.close();
                    return true;
                } else if (result['isDenied']) {
                    Swal.close();
                    window.$(".saveReservations").attr('disabled',true);
                } else if (result['isDismissed']) {
                    Swal.close();
                    window.$(".saveReservations").attr('disabled',true);
                }
            })
        }else{
            window.$(".saveReservations").attr('disabled',false);
            Swal.close();
            return true;
        }
    }else{
        Swal.fire({
            html: 'Restaurant not open in this time',
            title: '<strong>Time Matrix</strong>',
            icon: 'warning',
            allowOutsideClick: false,
        });
        return false;
    }
        
}
function sweetLoader(){
    var sweet_loader = '<div class="sweet_loader"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div>';
    Swal.fire({
        allowOutsideClick: false,
        html: sweet_loader+'<h4>Please Wait...</h4>',
        onRender: function() {
            $('.swal2-html-container').prepend(sweet_loader);
        }
    });

}

function sweetError(){
    
}

function sked(response) {
    if (response.data.events == undefined) {
        window.$('#sked').html(response.data.message);
        return;
    }
    var resourcesObject = response.data.resources;
    var eventsObject = response.data.events;
    var start_time = response.data.start_time;
    var end_time = response.data.end_time;
    window.$('#sked').html('');
    var $sked = window.$('#sked').skedTape({
        caption: 'Table / Pax',
        start: today(start_time, 0),
        end: today(end_time, 0),
        showEventTime: true,
        showEventDuration: true,
        scrollWithYWheel: true,
        locations: resourcesObject,
        events: eventsObject,
        formatters: {
            date: function (date) {
                return $.fn.skedTape.format.date(date, 'l', '/');
            }
        },
        snapToMins: 1,
        timeIndicatorSerifs: true,
        showIntermission: true,
        intermissionRange: [15, 30],
    });

    // The following handler fires on clicking on an event:
    $sked.on('event:click.skedtape', function (e /*, api*/) {
        e.preventDefault();
        window.$("#sidebarNavRight").css('width', '500px');
        Promise.resolve(1).then(function resolve() {
            if (e.detail.event.data.action == "show") {
                window.axios({
                    method: "get",
                    url: e.detail.event.data.url
                })
                    .then(function (response) {
                        window.$('#sidebar-modal-content').html(response.data);
                    })
            } else {
                window.axios({
                    method: "post",
                    url: e.detail.event.data.url,
                    data: {
                        'id': e.detail.event.data.reservation_id
                    }
                })
                    .then(function (response) {
                        window.$('#sidebar-modal-content').html(response.data);
                        setTimeout(function () {
                            commonDatepicker();
                            select2Dropdown();
                            reservationDatepicker();
                        }, 1000);
                    });
            }
        });
    });
}
//Next day function
$('body').on('click', '#timematrixCalendar button.fc-today-button', function () {

    var dateSelected = new Date(getDate());

    dateSelected.setDate(dateSelected.getDate());
    var p_date = ("0" + (dateSelected.getDate())).slice(-2);
    var p_month = ("0" + (dateSelected.getMonth() + 1)).slice(-2);
    var p_year = dateSelected.getFullYear();
    dateSelected = p_year + "-" + p_month + "-" + p_date;
    var resDate = p_date + "/" + p_month + "/" + p_year;
    getDailsNotes(dateSelected);
    $('#reservation_date').val(p_date + "." + p_month + "." + p_year);
    $("#visible_start").val(dateSelected);

    renderCalendar($("#lastRenderURL").val() + '?index=true&date=' + dateSelected + '&area_id=' + window.$('#area').val());
});
//Next day function
$('body').on('click', '#timematrixCalendar button.fc-next-button', function () {
    var start = $("#visible_start").val();
    //get next date
    if (start !== "") {
        var dateSelected = new Date(start);
    } else {
        var dateSelected = new Date(getDate());
    }

    dateSelected.setDate(dateSelected.getDate() + 1);
    var p_date = ("0" + (dateSelected.getDate())).slice(-2);
    var p_month = ("0" + (dateSelected.getMonth() + 1)).slice(-2);
    var p_year = dateSelected.getFullYear();
    dateSelected = p_year + "-" + p_month + "-" + p_date;
    var resDate = p_date + "/" + p_month + "/" + p_year;
    getDailsNotes(dateSelected);
    $('#reservation_date').val(p_date + "." + p_month + "." + p_year);
    $("#visible_start").val(dateSelected);

    renderCalendar($("#lastRenderURL").val() + '?index=true&date=' + dateSelected + '&area_id=' + window.$('#area').val());
});

//Previous day function
$('body').on('click', '#timematrixCalendar button.fc-prev-button', function () {
    var start = $("#visible_start").val();

    //get prev date
    if (start !== "") {
        var dateSelected = new Date(start);
    } else {
        var dateSelected = new Date(getDate());
    }
    dateSelected.setDate(dateSelected.getDate() - 1);
    var p_date = ("0" + (dateSelected.getDate())).slice(-2);
    var p_month = ("0" + (dateSelected.getMonth() + 1)).slice(-2);
    var p_year = dateSelected.getFullYear();
    dateSelected = p_year + "-" + p_month + "-" + p_date;
    var resDate = p_date + "/" + p_month + "/" + p_year;
    getDailsNotes(dateSelected);
    $('#reservation_date').val(p_date + "." + p_month + "." + p_year);
    $("#visible_start").val(dateSelected);

    renderCalendar($("#lastRenderURL").val() + '?index=true&date=' + dateSelected + '&area_id=' + window.$('#area').val());
});

// get next date
function getDate() {
    var currentDateObj = new Date();
    currentDateObj.setDate(currentDateObj.getDate());
    var p_date = ("0" + currentDateObj.getDate()).slice(-2);
    var p_month = ("0" + (currentDateObj.getMonth() + 1)).slice(-2);
    var p_year = currentDateObj.getFullYear();
    return p_year + "-" + p_month + "-" + p_date;
}

// get date format
function getDateFormat(currentDate) {
    if (!currentDate) {
        currentDate = new Date();
    }
    currentDate.setDate(currentDate.getDate());
    var p_date = ("0" + currentDate.getDate()).slice(-2);
    var p_month = ("0" + (currentDate.getMonth() + 1)).slice(-2);
    var p_year = currentDate.getFullYear();

    var date = p_year + "-" + p_month + "-" + p_date;
    window.$("#visible_start").val(date);

    return date;
}

function displayCalendar(ct) {
    var date = getDateFormat(ct);
    getDailsNotes(date);
    renderCalendar($("#lastRenderURL").val() + '?index=true&date=' + date + '&area_id=' + window.$('#area').val());
    setTimeout(function () {
        //triggerGlide();
    }, 1000)
}

// Inline datepicker
window.$('#reservation_date').datetimepicker({
    dayOfWeekStart: 1,
    format: DATE_FORMAT,
    timepicker: false,
    onSelectDate: function (ct, $i) {
        displayCalendar(ct);
    },
    onChangeYear: function (ct, $i) {
        displayCalendar(ct);

    },
    onChangeMonth: function (ct, $i) {
        displayCalendar(ct);
    }
});

window.$(document).on('change', '.timeMatrixCalender #area', function (e) {
    renderCalendar($("#lastRenderURL").val() + '?index=true&date=' + $("#visible_start").val() + '&area_id=' + window.$('#area').val());
});

let arr1 = [];
window.$(document).on('change', '.tables_overbooking', function (e) {
    checkOverBooking();
    var tables_id = $("#tables_id").val();
    var highlightIds = tables_id.toString().split(',');
    //console.log(tables_id);
    let arr2 = tables_id;
    let scrolltable = arr2.filter(x => arr1.indexOf(x) === -1);
    arr1 = arr2;
    if (scrolltable !== "") {
        highlightTable(scrolltable[0]);
    }

    $('.fc-timeline-lane').css('background-color','');
    if(highlightIds != ''){
        highlightIds.forEach(highlightRows);
    }
    
});

function highlightRows(value, index, array) {
    var trg = $("#" + value).parent().attr('data-resource-id');
    $('.fc-timeline-lane[data-resource-id="' + trg + '"]').css('background-color','rgba(0,0,0,0.2)');
}
 

function highlightTable(scrolltable) {
    if(scrolltable){
        $('html, body').animate({
            scrollTop: ($(`#` + scrolltable).offset().top - ($('.navbar').height() + 50 + $('.fc-scrollgrid-section-sticky').height()))
        }, 2000);
    }
}
function checkOverBooking() {
    //console.log(window.$(".reservationsForm #tables_id").attr('data-url'));
    window.axios({
        method: "post",
        url: window.$(".reservationsForm #tables_id").attr('data-url'),
        data: window.$(".reservationsForm").serialize(),
    })
        .then(function (response) {
            if (response.data.status == "success") {
                $("#overBooking").removeClass('d-none');
            } else {
                $("#overBooking").addClass('d-none');

            }
        });
}
// -------------------------- Helpers ------------------------------
function today(hours, minutes) {
    var date = '';
    if (window.$("#visible_start").val() !== '') {
        date = new Date(window.$("#visible_start").val());
    } else {
        date = new Date();
    }
    date.setHours(hours, minutes, 0, 0);
    return date;
}
var triggerGlide = function () {
    var sliders = document.querySelectorAll('.multi1');

    for (var i = 0; i < sliders.length; i++) {
        var glide = new Glide(sliders[i], {

            startAt: 0,
            autoplay: 3500,
            perView: 3,
            animationDuration: 2000,
            hoverpause: true,
        });
        glide.mount()
    }
};
// var glideMulti1 = new Glide('.multi1', {
//     type: 'carousel',
//     autoplay: 3500,
//     perView: 3
//   });
// glideMulti1.mount();
/*
    Carousel
*/
// $('#daily-notes-carousel').on('slide.bs.carousel', function(e) {


//     var $e = $(e.relatedTarget);
//     var idx = $e.index();
//     var itemsPerSlide = 4;
//     var totalItems = $('.carousel-item').length;

//     if (idx >= totalItems - (itemsPerSlide - 1)) {
//         var it = itemsPerSlide - (totalItems - idx);
//         for (var i = 0; i < it; i++) {
//             // append slides to end
//             if (e.direction == "left") {
//                 $('.carousel-item').eq(i).appendTo('.carousel-inner');
//             } else {
//                 $('.carousel-item').eq(0).appendTo('.carousel-inner');
//             }
//         }
//     }
// });


$('#daily-notes-carousel').carousel({
    interval: 2000
});


function getDailsNotes(date) {
    // console.log(date)
    window.axios({
        method: "post",
        url: window.$('#dailynotes-content').attr('data-url'),
        data: {
            'start': date,
            'end': date,
            'restaurant_id': window.$('restaurant_id').val()
        }
    })
        .then(function (response) {
            window.$('#dailynotes-content').html(response.data);
            setTimeout(function () {
                //triggerGlide();
            }, 1000)
        });
}

$(document).on('click', '.timeMatrixCalender .createDailyNotes', function (e) {
    window.$('.richText-editor').html('');
    window.$('#daily_note_id').val('');
    window.$('#dailyModal textarea').val('');
    window.$("#dailyModal").modal("show");
    window.$('#dailyModal .delete-icon').hide();
    window.$('#dailyModal .updated_info').text('');
    window.$('#dailyModal .created_info').text('');
    let reser_Date = window.$("#reservation_date").val();
    window.$("#notes_start_date").val(reser_Date);
    window.$("#notes_end_date").val(reser_Date);
})

$(document).on('click', '#dailynotes-content .editDailyNotes', function (e) {
    window.$("#dailyModal").modal("show");
    window.$('#notes_error').empty();
    //window.$('#dailyModal textarea').val(window.$(this).attr('data-title'));
    window.$('#dailyModal .richText-editor').html(window.$(this).attr('data-title'));
    window.$('#dailyModal #daily_note_id').val(window.$(this).attr('data-id'));
    window.$('#dailyModal .delete-icon').show();
    window.$('#dailyModal .updated_info').text(window.$(this).attr('data-updated_info'));
    window.$('#dailyModal .created_info').text(window.$(this).attr('data-created_info'));
    window.$("#notes_start_date").val(window.$(this).attr('data-startdate'));
    window.$("#notes_end_date").val(window.$(this).attr('data-enddate'));
    if (window.$(this).attr('data-dissrc') == 'widget') {
        window.$("#widgetDailyNotes").attr("checked", false);
        window.$("#tabletDailyNotes").attr("checked", false);
        window.$("#widgetDailyNotes").attr("checked", true);
    } else if (window.$(this).attr('data-dissrc') == 'app') {
        window.$("#widgetDailyNotes").attr("checked", false);
        window.$("#tabletDailyNotes").attr("checked", false);
        window.$("#tabletDailyNotes").attr("checked", true);
    } else if (window.$(this).attr('data-dissrc') == 'all') {
        window.$("#widgetDailyNotes").attr("checked", false);
        window.$("#tabletDailyNotes").attr("checked", false);
        window.$("#widgetDailyNotes").attr("checked", true);
        window.$("#tabletDailyNotes").attr("checked", true);
    }
})

/**
 * Save the daily note
 */
window.$(document).on('click', '.dailyNotesTimematrix .save-icon', function () {
    window.$('#dailyNotes').find('#notes').val(window.$('#dailyNotes').find('.richText-editor').html());
    var notes = window.$('#dailyNotes').find('#notes').val();
    
 
    var id = window.$('#daily_note_id').val();
    //  checked for update or add 
    if (typeof id == "undefined") {
        id = '';
    }
    if (!window.$('#tabletDailyNotes').is(':checked') && !window.$('#widgetDailyNotes').is(':checked')) {
        window.toastr.error("Please select where you want your Daily Note to be visible.", "Required");
        return false;
    }
    var date = $("#visible_start").val();
    var querySting = (id != '') ? ('/' + id) : '';
    window.axios({
        method: (id != '') ? 'PUT' : 'POST',
        url: window.$("form#dailyNotes").attr('action') + querySting,
        data: window.$("form#dailyNotes").serialize() + '&date=' + date + '&id=' + id,
    }).then(function (response) {
        window.toastr.success(response.data.message, response.statusText);
        window.$("#dailyModal").modal("hide");
        // Refresh calendar
        getDailsNotes(date);
        setTimeout(function () {
            //triggerGlide();
        }, 1000)

    }).catch(function (error) {
        if (error.response.status == 400) {
            window.$.each(error.response.data, function (key, value) {
                window.toastr.error(error.response.data.message, error.response.data.statusText);
            });
            return false;
        }
        window.toastr.error(error.response.data.message, error.response.data.statusText);

    });

});

/**
 * Delete the daily note
 */
window.$('.dailyNotesTimematrix .delete-icon').on('click', function () {
    // get selected date
    var date = $("#visible_start").val();
    // Call method for delete confirmation
    var promise = deleteConfirmationAlert();
    $("#dailyModal").removeAttr("style").attr("style", "display:block");
    promise.then(function (result) {
        // If confirmation true, do action for delete
        var id = window.$('#daily_note_id').val();
        window.axios({
            method: 'DELETE',
            url: window.$("form#dailyNotes").attr('action') + '/' + id,
        }).then(function (response) {
            window.toastr.success(response.data.message, response.statusText);
            window.$("#dailyModal").modal("hide");
            setTimeout(() => {
                window.$("#dailyModal").removeAttr('style').attr("style", "z-index:999999 !important; display:none !important");
            }, 800)
            // Refresh calendar
            getDailsNotes(date);
            setTimeout(function () {
               // triggerGlide();
            }, 1000)
        }).catch(function (error) {
            window.toastr.error(error.response.data.message, error.response.data.statusText);
        });
    }).catch(function (err) {
        // console.log(err);
        return false;
    });
});

function renderTimeList() {
    var times = []; // time array
    var timeListDom = '';
    times = getTimeListOnly();
    times.forEach(function (val) {
        timeListDom += '<option data-tokens="' + val + '" value="' + val + '">' + val + '</option>';
    });
    // $(".create_walkin_start_time").html(timeListDom);
    // $(".create_walkin_end_time").html(timeListDom);
    // // $("#start_time").html(timeListDom);
    // // $("#end_time").html(timeListDom);
}

function getTimeListOnly() {
    var x = parseInt(MIN_INTERVAL); //minutes interval
    var times = []; // time array
    var tt = 0; // start time
    //loop to increment the time and push results in array
    for (var i = 0; tt < 24 * 60; i++) {
        var hh = Math.floor(tt / 60); // getting hours of day in 0-24 format
        var mm = (tt % 60); // getting minutes of the hour in 0-55 format
        times[i] = ("0" + (hh % 24)).slice(-2) + ':' + ("0" + mm).slice(-2); // pushing data in array in [00:00 - 12:00 AM/PM format]
        tt = tt + x;
    }
    return times;
}

function calculateRetentionHour() {
    let h, m;
    let slotStartTime = window.$("#start_time").val();
    $.ajax({
        url: window.$('#start_time').attr('settingurl'),
        type: 'post',
        dataType: "json",
        data: {
            _token: window.$('meta[name="csrf-token"]').attr('content'),
            startTime: slotStartTime,
            no_of_guests: window.$("#label-no_of_guests").val(),
            restaurant_id: window.$('#restaurants').val(),
            date: window.$("#label-reservation_date").val()
        },
        success: function (data) {
            if (data.data) {
                h = data.data.h;
                m = data.data.m;
                endTime = h + ':' + m;
                let slotsEndTime = addTimes(slotStartTime, endTime);
                $(".walkin_end_time").select2().val(slotsEndTime).trigger("change");
                if(document.getElementById('selected_end_time')){
                let selected_end_time = document.getElementById('selected_end_time').value;
                if(selected_end_time){
                    slotsEndTime = selected_end_time;
                }
                }
                $("#end_time").select2().val(slotsEndTime).trigger("change");
            }
        }
    });
}
window.$(document).on('change', '#label-no_of_guests', function (e) {
    if(window.$("#edit_flag").val() != "edit_flag"){
        if (!checkCover)
            calculateRetentionHour();
    }
    setTimeout(()=>{
        checkOverBooking();
    },550);
});

window.$(document).on('change','#end_time',function(e){
    getAvailableTable();
    setTimeout(()=>{
        checkOverBooking();
    },550);
});
window.$(document).on('change', '#start_time,.walkin_start_time', function (e) {
    if(!askedConfirmation) {
        let endTimeSlotDom = '';
        let slotStartTime = $(this).val();
        calculateRetentionHour();
    // checkOverBooking();
        sweetLoader();
        checkTimIsAvailableWhileTimeChange(slotStartTime);
        setTimeout(()=>{
            checkOverBooking();
        },350);
        sweetLoader();
        //alert(askedConfirmation)
        if(!askedConfirmation){
            checkTimIsAvailableWhileTimeChange(slotStartTime);
        }else{
            Swal.close();
            askedConfirmation = false;
        }

        let endSlotStartFrom = addMinutes(slotStartTime, MIN_INTERVAL);
        let timeList = getTimeListOnly();
        let exactIndex = timeList.indexOf(endSlotStartFrom);
        timeList.forEach(function (val, indx) {
            if (indx >= exactIndex) {
                endTimeSlotDom += '<option data-tokens="' + val + '" value="' + val + '">' + val + '</option>';
            }
        });

        $("#end_time").html(endTimeSlotDom)
        //getAvailableTable();
    }
    else{
        Swal.close();
        askedConfirmation = false;
    }
    getAvailableTable();
});

function addMinutes(time, minsToAdd) {
    function D(J) { return (J < 10 ? '0' : '') + J; };
    var piece = time.split(':');
    var mins = piece[0] * 60 + +piece[1] + +minsToAdd;

    return D(mins % (24 * 60) / 60 | 0) + ':' + D(mins % 60);
}

function addTimes(startTime, endTime) {

    // console.log(endTime);
    var times = [0, 0, 0]
    var max = times.length

    var a = (startTime || '').split(':')
    var b = (endTime || '').split(':')

    // normalize time values
    for (var i = 0; i < max; i++) {
        a[i] = isNaN(parseInt(a[i])) ? 0 : parseInt(a[i])
        b[i] = isNaN(parseInt(b[i])) ? 0 : parseInt(b[i])
    }

    // store time values
    for (var i = 0; i < max; i++) {
        times[i] = a[i] + b[i]
    }

    var hours = times[0]
    var minutes = times[1]

    if (minutes >= 60) {
        var h = (minutes / 60) << 0
        hours += h
        minutes -= 60 * h
    }

    return ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2)
}
window.addEventListener('DOMContentLoaded', (event) => {
    setTimeout(function () {
        //triggerGlide();
    }, 1000)
});
document.addEventListener("DOMContentLoaded", function (e) {
    e.preventDefault();
    var qs = (function (a) {
        if (a == "") return {};
        var b = {};
        for (var i = 0; i < a.length; ++i) {
            var p = a[i].split('=', 2);
            if (p.length == 1)
                b[p[0]] = "";
            else
                b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
        }
        return b;
    })(window.location.search.substr(1).split('&'));
    if (qs['guestId'] != '' && qs['src'] == 'guest') {
        $(".createReservation").trigger('click');
    }
    window.$(document).on('change', "#area_id", function (e) {
        let selectedArea = $(this).val();
        $("#area").select2().val(selectedArea).trigger("change");
    });
    setTimeout(() => {
        window.$('.reservation_phase_lists').select2({
            placeholder: DROPDOWN_SINGLE_SELECT_PLACEHOLDER,
        });
        $(".reservation_phase_lists").nextAll('span').addClass('d-none')
        let dropdown = $('.reservation_phase_lists');
        for (let index = 0; index < dropdown.length; index++) {
            const element = $('.reservation_phase_lists:eq(' + index + ')').val()
            //if (element == "") {
            $('.reservation_phase_lists:eq(' + index + ')').next('span').addClass('d-none');
            //}
        }
        window.$(".phaseIconInList").show();


    }, 2000);

    window.$(document).on('click', '.phaseIconInList', function () {
        let phaseId = $(this).attr('phase_id');
        window.$("#" + phaseId).next('span').removeClass('d-none');
        window.$(this).addClass('d-none');
    });

});
window.$(document).on('change', '.reservationsTable .reservation_phase_lists', function (e) {
    window.$(".error").html('');
    window.toastr.remove();
    $(this).select2().trigger("select2:close");
    var myTable = $(".reservationsTable").DataTable({
        bRetrieve: true,
        ajax: window.$(".reservationsTable").attr('link'),
        initComplete: function () {

        }
    });
    var id = $(this).attr("id");
    if (typeof id !== "undefined" && id !== '') {
        var url = window.$(this).attr('link'),
            phase_id = $("[phase_dropdown=" + id + "]").val()
        window.axios({
            method: "put",
            url: url,
            data: {
                'id': id,
                'reservation_phase_id': phase_id,
                'phase_update': true
            }
        })
            .then(function (response) {
                window.toastr.success(response.data.message, response.statusText);
                //myTable.ajax.reload();
                window.$('.reservationsTable').DataTable().ajax.reload(null, false);
                setTimeout(() => {
                    window.$('.reservation_phase_lists').select2({
                        placeholder: DROPDOWN_SINGLE_SELECT_PLACEHOLDER,
                    });
                    let dropdown = $('.reservation_phase_lists');
                    for (let index = 0; index < dropdown.length; index++) {
                        const element = $('.reservation_phase_lists:eq(' + index + ')').val()
                        if (element == "") {
                            $('.reservation_phase_lists:eq(' + index + ')').next('span').addClass('d-none');
                        }
                    }
                    $(".reservation_phase_lists").nextAll('span').addClass('d-none')
                    window.$(".phaseIconInList").show();
                    // $("[phase_dropdown=" + id + "]").select2('close')

                }, 2000);
            })
    }
});
$(document).on('click','body *',function(eve){
    let enableVal = $(".reservationsTable").find(".select2").not(".d-none").prev('select').val();
    if (enableVal == '') {

    }
})
window.$(document).on("click", ".addPhase", function () {
    let reservation_id = $(this).attr('reservation_id');
    window.$('.reservation_phase_lists').select2({
        placeholder: DROPDOWN_SINGLE_SELECT_PLACEHOLDER,
    });
    $('.reservation_phase_lists').next('span').addClass('d-none');
    $(".phasePlusIcon").removeClass('d-none');
    $("img.phaseIconInList").next().next().next(".phasePlusIcon").addClass("d-none")
    $(".phasePlusIcon").prev().prev().prev("img").show();
    $(".phasePlusIcon").prev().prev().prev("img").removeClass('d-none');
    $("[reservation_id=" + reservation_id + "]").siblings('span').removeClass('d-none')
    $(this).addClass('d-none');
    $("[phase_dropdown=" + reservation_id + "]").select2('open')
    let dropdown = $('.reservation_phase_lists');
    for (let index = 0; index < dropdown.length; index++) {
        const element = $('.reservation_phase_lists:eq(' + index + ')').val()
        if (element !== "") {
            //$('.reservation_phase_lists:eq(' + index + ')').next('span').removeClass('d-none');

        }
    }
});


window.$('body').on('click', '.status_checkbox', function(e) {
    if (window.$(this).prop('checked')==true){ 
        window.$(".reservationLangValue").removeClass('d-none');
        window.$(".reservationLangValue").show();
    }
    else{
        window.$(".reservationLangValue").hide();
    }
});

function dragAndDrop(info,infoData)
{
    window.$(".matrixPleasewait").show();
    var startStr = info.event.startStr;
    var startDate = new Date(startStr);
    var startHours = startDate.getHours();
    var startMinutes = startDate.getMinutes();
    var startTime = startHours + ':' + startMinutes;

    var endStr = info.event.endStr;
    var endDate = new Date(endStr);
    var endHours = endDate.getHours();
    var endMinutes = endDate.getMinutes();
    var endTime = endHours + ':' + endMinutes;
    //info.oldEvent.start = info.event.start;
    //console.log(info.event.startStr)
    //console.log(info.oldEvent.startStr);
    let current_table_id = info.event._def.extendedProps.data.table_id;
    let new_table_id = (typeof info.newResource !== 'undefined' && info.newResource !== null) ? info.newResource._resource.extendedProps.table_id : current_table_id;
    let old_table_id = (typeof info.oldResource !== 'undefined'  && info.oldResource !== null) ? info.oldResource._resource.extendedProps.table_id : current_table_id;
    // console.log(checkTimIsAvailableWhileTimeChange(startTime));
    // if(true){
    //     window.$(".matrixPleasewait").hide();
    //     info.revert();
    // }else{
    function dragReservationUpdate() {
        Promise.resolve(1).then(function resolve() {
        window.axios({
            method: "post",
            url: infoData.dragdropupdateurl,
            data: {
                'id': infoData.reservation_id,
                'start_time': startTime,
                'end_time': endTime,
                'new_table_id': new_table_id,
                'old_table_id': old_table_id,
                'reservationDragged': true,
                'reservation_date': window.$("#reservation_date").val(),
            }
        })
            .then(function (response) {
                let old_reservationId = info.oldEvent._def.extendedProps.data.reservation_id;
                let old_tableId = info.oldEvent._def.extendedProps.data.table_id;
                /* OLD START TIME FORMAT */
                let old_startStr = info.oldEvent.startStr;
                let old_startDate = new Date(old_startStr);
                let old_startHours = old_startDate.getHours();
                let old_startMinutes = old_startDate.getMinutes();
                let old_startTime = old_startHours + ':' + old_startMinutes;

                /* OLD END TIME FORMAT */
                let old_endStr = info.oldEvent.endStr;
                let old_endDate = new Date(old_endStr);
                let old_endHours = old_endDate.getHours();
                let old_endMinutes = old_endDate.getMinutes();
                let old_endTime = old_endHours + ':' + old_endMinutes;
                window.$(".matrixPleasewait").hide();
                window.toastr.success("<button type='button' style='color:white;' id='' resId='" + response.data.data['reservation_id'] + "' newTableId='" + response.data.data['newTableId'] + "' oldTableId='" + response.data.data['oldTableId'] + "' class='confirmationRevertYes btn clear'>Undo</button></br>", response.data.message,
                    {
                        closeButton: false,
                        allowHtml: true,
                        showDuration: "100000",
                        hideDuration: "100000",
                        // "timeOut": "500000",
                        // "extendedTimeOut": "100000",
                        onShown: function (toast) {
                            window.$(".confirmationRevertYes").on('click', function () {
                                window.$(".matrixPleasewait").show();
                                let undoresId = $(this).attr('resId');
                                let undonewTableId = $(this).attr('newTableId');
                                let undooldTableId = $(this).attr('oldTableId');
                                if (undoresId == old_reservationId) {
                                    window.axios({
                                        method: "post",
                                        url: infoData.dragdropupdateurl,
                                        data: {
                                            'id': old_reservationId,
                                            'start_time': old_startTime,
                                            'end_time': old_endTime,
                                            'new_table_id': undonewTableId,
                                            'old_table_id': undooldTableId,
                                            'reservationDragged': true,
                                        }
                                    }).then(function (response) {
                                        window.$(".matrixPleasewait").hide();
                                        window.toastr.success("Successfully undo the reservation");
                                        info.revert();
                                    }).catch(function (error) {
                                        window.$(".matrixPleasewait").hide();
                                        window.toastr.error(error.response.data.message, error.response.data.statusText);
                                    });
                                }
                            });
                        }
                    });
                renderCalendar($("#lastRenderURL").val() + '?index=true&date=' + $("#visible_start").val() + '&area_id=' + window.$('#area').val());
            }).catch(function (error) {
                window.$(".matrixPleasewait").hide();
                window.toastr.error(error.response.data.message, error.response.data.statusText);
                info.revert();
            });
    });
}
// SWEET ALERT TESTED PART START HERE
function calendarMatrixSweetAlert(info){
    Swal.fire({
        title: '<strong>Time Matrix</strong>',
        icon: 'info',
        allowOutsideClick: false,
        html: 'Please note, that your restaurant is closed for this time slot - are you sure you want to make a reservation?',
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: 'Yes',
        focusConfirm: false,
        cancelButtonText: "No",
    }).then((result) => {
        if (result['isConfirmed']) {
            Swal.close();
            window.$(".saveReservations").attr('disabled',false);
            dragReservationUpdate();

        } else if (result['isDenied']) {
            Swal.close();
            info.revert()
        } else if (result['isDismissed']) {
            Swal.close();
            info.revert()
        }
    })
}
let splitTime = startTime.split(':');
let hourSplit = (splitTime[0].length == 2) ? splitTime[0] : '0'+splitTime[0];
let minSplit = (splitTime[1].length == 2) ? splitTime[1] : '0'+splitTime[1];
let finalTime = hourSplit+':'+minSplit;

if(resOpenTime.includes(finalTime) || resExpOpenTime.includes(finalTime)){
    if(resCloseTime.length > 0 && resCloseTime.includes(finalTime)){
        calendarMatrixSweetAlert(info);
    }else if(resExpCloseTime.length > 0 && resExpCloseTime.includes(finalTime)){
        calendarMatrixSweetAlert(info);
    }else{
        Swal.close();
        dragReservationUpdate();
    }
}else{
    Swal.fire({
        html: 'Restaurant not open in this time',
        title: '<strong>Time Matrix</strong>',
        icon: 'warning',
        allowOutsideClick: false,
    });
    info.revert();
}
window.$(".matrixPleasewait").hide();
// SWEET ALERT TESTED PART END HERE

//}
}


window.$(document).on('click', '.viewReservationHistory', function (e) {
    $.ajax({
        url: window.$(this).attr('data-url'),
        type: 'get',
        success: function (data) {
            checkTimIsAvailableWhileTimeChanges(data);
        }
    });

});
function checkTimIsAvailableWhileTimeChanges(data) {
    Swal.fire({
        allowOutsideClick: false,
        html: data,
        showDenyButton: false,
        showCancelButton: true,
        customClass: 'swal2-popups',
        // confirmButtonText: 'Yes',
        focusConfirm: false,
        cancelButtonText: "No",
    }).then((result) => {
        if (result['isConfirmed']) {
            return true;
        }
    })
}
 
export { displayCalendar }
